import template from './adpNotificationIcon.html';
import controller from './adpNotificationIcon.controller';
import './adpNotificationIcon.less';

let adpNotificationIconComponent = {
  restrict: 'E',
  bindings: {},
  template,
  controller
};

export default adpNotificationIconComponent;



// WEBPACK FOOTER //
// ./src/app/components/adpNotificationIcon/adpNotificationIcon.component.js